// extracted by mini-css-extract-plugin
module.exports = {"section":"TtsSettings_section__3Z6q4","textfield":"TtsSettings_textfield__3Ni5V","errorIcon":"TtsSettings_errorIcon__ut8ui"};